import { useMemo } from 'react';
import { TreeType, TreeViewBy } from '../types';
import {
  TREE_NODE,
  TREE_TYPE,
  TREE_VIEW_BY,
  VIEW_ID,
} from '../constants/urlParams';
import useSearchParams from './useSearchParams';

type TreeViewParamsReturnValue = {
  treeViewBy: TreeViewBy;
  defaultTreeViewBy: TreeViewBy;
  treeType: TreeType;
  setTreeViewBy: (value: string) => void;
  setTreeType: (value: string) => void;
  deleteTreeViewBy: () => void;
  deleteTreeType: () => void;
  urlTreeNode: string | null;
  urlSavedView: string | null;
};

const useTreeViewParams = (): TreeViewParamsReturnValue => {
  const [searchParams, setSearchParams] = useSearchParams();

  const treeType = useMemo(
    () => searchParams.get(TREE_TYPE) || 'data_assets',
    [searchParams],
  );

  const defaultTreeViewBy = treeType === 'data_assets' ? 'dbt' : 'paths';

  const treeViewBy = useMemo(
    () => searchParams.get(TREE_VIEW_BY) || defaultTreeViewBy,
    [searchParams, defaultTreeViewBy],
  );

  const urlTreeNode = useMemo(
    () => searchParams.get(TREE_NODE),
    [searchParams],
  );

  const urlSavedView = useMemo(() => searchParams.get(VIEW_ID), [searchParams]);

  const setTreeViewBy = (value: string) => {
    searchParams.set(TREE_VIEW_BY, value);
    setSearchParams(searchParams);
  };

  const deleteTreeViewBy = () => {
    searchParams.delete(TREE_VIEW_BY);
    setSearchParams(searchParams);
  };

  const setTreeType = (value: string) => {
    searchParams.set(TREE_TYPE, value);
    setSearchParams(searchParams);
  };

  const deleteTreeType = () => {
    searchParams.delete(TREE_TYPE);
    setSearchParams(searchParams);
  };

  return {
    defaultTreeViewBy,
    treeViewBy: treeViewBy as TreeViewBy,
    treeType: treeType as TreeType,
    setTreeViewBy,
    setTreeType,
    deleteTreeViewBy,
    deleteTreeType,
    urlTreeNode,
    urlSavedView,
  };
};

export default useTreeViewParams;
